package org.example.project.ui.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.client.model.ActivityResponse
import org.example.project.ui.theme.EditorColors

@Composable
fun PublishConfirmDialog(
    activity: ActivityResponse,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    text = "Potwierdzenie publikacji zabawy",
                    fontSize = 18.sp,
                    fontWeight = FontWeight.Bold,
                    color = EditorColors.TextPrimary
                )
            }
        },
        text = {
            Column {
                Text(
                    text = "Czy na pewno chcesz opublikować poniższą zabawę? Po opublikowaniu stanie się ona widoczna publicznie w katalogu aplikacji.",
                    fontSize = 14.sp,
                    color = EditorColors.TextSecondary,
                    lineHeight = 20.sp
                )
                Spacer(modifier = Modifier.height(16.dp))
                Surface(
                    shape = RoundedCornerShape(12.dp),
                    color = EditorColors.SurfaceSubtle,
                    border = BorderStroke(1.dp, EditorColors.BorderSubtle),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Column(modifier = Modifier.padding(14.dp)) {
                        Text(
                            text = activity.name,
                            fontSize = 15.sp,
                            fontWeight = FontWeight.Bold,
                            color = EditorColors.TextPrimary
                        )
                        Spacer(modifier = Modifier.height(6.dp))
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(8.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(
                                text = "Kategoria: ${activity.category}",
                                fontSize = 12.sp,
                                color = EditorColors.TextMuted
                            )
                            Text(
                                text = "•",
                                fontSize = 12.sp,
                                color = EditorColors.BorderStrong
                            )
                            Text(
                                text = "Wiek: ${activity.minAge}–${activity.maxAge} lat",
                                fontSize = 12.sp,
                                color = EditorColors.TextMuted
                            )
                            Text(
                                text = "•",
                                fontSize = 12.sp,
                                color = EditorColors.BorderStrong
                            )
                            Text(
                                text = "${activity.durationMinutes} min",
                                fontSize = 12.sp,
                                color = EditorColors.TextMuted
                            )
                        }
                    }
                }
            }
        },
        confirmButton = {
            Button(
                onClick = onConfirm,
                shape = RoundedCornerShape(8.dp),
                colors = ButtonDefaults.buttonColors(
                    containerColor = EditorColors.SuccessSolid,
                    contentColor = EditorColors.Surface
                )
            ) {
                Text("Tak, opublikuj", fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
            }
        },
        dismissButton = {
            OutlinedButton(
                onClick = onDismiss,
                shape = RoundedCornerShape(8.dp),
                border = BorderStroke(1.dp, EditorColors.BorderStrong)
            ) {
                Text("Anuluj", fontSize = 13.sp, color = EditorColors.TextSecondary)
            }
        },
        shape = RoundedCornerShape(16.dp),
        containerColor = EditorColors.Surface
    )
}
